import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { getAlmaAjoLogo } from 'lib/images'
import { getLocale } from 'lib/utils/getLocale'

import { AppRootContext } from 'components/App'
import Link from 'components/Link'

import './app-header-logo.pcss'

const AppHeaderLogo = ({ title }) => {
    const { breakpoints } = useContext(AppRootContext)
    const { i18n } = useTranslation(['common'])

    return (
        <h1 className="app-header-logo">
            <Link
                to={`${getLocale(i18n.language) || '/'}`}
                title={title}
                trackName="logo"
            >
                <div className="app-header-logo__container">
                    {breakpoints.up('containerM')
                        ? getAlmaAjoLogo(true, 'white')
                        : getAlmaAjoLogo(true, 'white', true)}
                </div>
            </Link>
        </h1>
    )
}

export default React.memo(AppHeaderLogo)
